import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/fontawesome/darkest/solid/circle-play.svg")